import { MDBIcon } from "mdb-react-ui-kit";
import { useContext } from 'react';
import useResumeDiplomasHandlers from "../../../context/resume/hooks/resume-diplomas-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";

export default function AddDiploma() {

    const { translations } = useContext( TranslationContext );
    const { handleAdd } = useResumeDiplomasHandlers();

    return (
        <button className="btn_primary" onClick={ handleAdd }>
            <MDBIcon fas
                     icon="plus-circle"
                     color='light'
                     size='sm'
                     title={ translations.diplomasSection.addDiplomaLabel }
            />
            <span className='ms-1'>{ translations.diplomasSection.addDiplomaLabel }</span>
        </button>
    )
}
